/**
 * Login
 */
//New Stuff
import React, { useEffect } from 'react';
import queryString from 'query-string';
import { useLocation, withRouter } from 'react-router-dom';

// UI
import { makeStyles } from '@material-ui/core/styles';

// Type
import { Props } from './interfaces';
import { CircularProgress, Grid } from '@material-ui/core';
import loginRepository from 'client-sdk/src/Repository/login-repository';
import enviroment from 'client-sdk/src/enviroments/enviroment';
import history from '../../utils/history';

// Style
const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
    overflow: 'hidden',
  }
}));
// utils
import getEnv from '../../utils/getEnv';

function R2Login(props: Props) {

  const { search } = useLocation();
  const queryValues = queryString.parse(search);

  useEffect(() => {
    localStorage.clear()
  }, []);

  useEffect(() => {
    if (queryValues.code) {
      loginRepository.oAuthentication({
        payload: {
          code: queryValues.code
        }
      }).then(res => {
        res.data && localStorage.setItem('token', res.data.token);
        res.data && localStorage.setItem('role', res.data.role);
        res.data?.partnerId && localStorage.setItem('partnerId', res.data.partnerId);
        res.data && localStorage.setItem('name', res.data.name);
        res.data?.userId && localStorage.setItem('userId', JSON.stringify(res.data.userId));
        window.location.pathname = '/orders'
        localStorage.setItem('logintype', 'r2')
      }).catch(err => {
        if (err.response.status === 400) {
          window.location.replace(getEnv().account + '/protocol/openid-connect/auth?client_id=ronad&response_type=code&redirect_uri=' +
            encodeURIComponent(`${getEnv().panel}/r2`))
        }
      })
    }
  }, []);

  const classes = useStyles();
  return (
    <>
      <Grid container component="main" alignItems='center' justifyContent='center' className={classes.root}>
        <div className='text-center'>
          <h1>درحال ورود به پنل روناد</h1>
          <CircularProgress />
        </div>
      </Grid>
    </>
  );
}

export default withRouter(R2Login);
